module.exports = __webpack_public_path__ + "media/images/how_it_works/step-5-6ef660f1c3c114a78473d1b51685f4ab.svg";